import './PdfViewer.css';
import { observer } from 'mobx-react';
import { RPProvider, RPDefaultLayout, RPPages, RPConfig, ZoomLevel } from '@pdf-viewer/react'
import { Appl } from '../../Appl';

class PdfProps {
  data?: any;
};

//https://www.react-pdf.dev/manage-license
export const PdfViewer: React.FC<PdfProps> = observer((props: { data?: any }) => {

  function url() {
    let blob = new Blob([props.data], { type: 'application/pdf' });
    let blobUrl = URL.createObjectURL(blob);
    return blobUrl;
  }

  return (
    <>
      {props.data &&
        // <iframe id="pdfIframe" src={`${url()}`} className="pdf-viewer-container" />
        <RPConfig licenseKey={Appl.Setting.PdfSiteKey}>
          <RPProvider src={`${url()}`} initialScale={ZoomLevel.PAGE_WIDTH} darkMode={true}>
            <RPDefaultLayout style={{ height: '100dvh' }} slots={{
              sidebarEnable: true,
              openFileTool: false,
              selectionModeTool: false,
              scrollModeTool: false,
            }}>
              <RPPages />
            </RPDefaultLayout>
          </RPProvider>
        </RPConfig>
      }
    </>
  );
});


